import React from 'react'
import { PageFooterConsumer, AppToolbarConsumer } from '../../../components'
import { Outlet } from 'react-router-dom'
import { Container, Grid } from '@mui/material'
import { useStyles } from './style'

const ConsumerPrimaryLayout = () => {
  const classes = useStyles()
  return (
    <>
      <Container className={classes.appBarContainer} maxWidth={false} id='appbar-container'>
        <AppToolbarConsumer />
      </Container>
      <Grid
        container
        direction='column'
        wrap='nowrap'
        className={classes.container}
      >
        <Grid item className={classes.mainContainer}>
          <main>
            <Outlet />
          </main>
        </Grid>
        <Grid item className={classes.footerContainer}>
          <footer>
            <PageFooterConsumer />
          </footer>
        </Grid>
      </Grid>
    </>
  )
}

export default ConsumerPrimaryLayout
